import { Injectable } from '@angular/core';
import { TaskGroupService } from '@app/core/services/task-group.service';
import { createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, of, switchMap } from 'rxjs';
import { TranslatableEffect } from '../../i18n/TranslatableEffects';
import { TaskGroupsActions } from '../task-groups/task-groups.actions';
import { ToastActions } from '../toast/toast.actions';
import { TaskGroupActions } from './task-group.actions';

@Injectable()
export class TaskGroupEffects extends TranslatableEffect {
  createTaskGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TaskGroupActions.create),
      switchMap(({ cmd }) =>
        this.taskGroupService.createTaskGroup(cmd).pipe(
          mergeMap((taskGroup) => [
            TaskGroupsActions.load(),
            ToastActions.showInfoMessage({ summary: this.translate('taskGroupSaved'), detail: '' }),
            TaskGroupActions.createTaskGroupSucceeded({ taskGroup }),
          ]),
          catchError(() =>
            of(
              ToastActions.showErrorMessage({
                summary: this.translate('somethingWentWrong'),
                detail: this.translate('pleaseTryAgainOrContactSupport'),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  updateTaskGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TaskGroupActions.update),
      switchMap(({ id, cmd }) =>
        this.taskGroupService.updateTaskGroup(id, cmd).pipe(
          mergeMap((taskGroup) => [
            TaskGroupsActions.load(),
            ToastActions.showInfoMessage({ summary: this.translate('taskGroupSaved'), detail: '' }),
            TaskGroupActions.updateTaskGroupSucceeded({ taskGroup }),
          ]),
          catchError(() =>
            of(
              ToastActions.showErrorMessage({
                summary: this.translate('somethingWentWrong'),
                detail: this.translate('pleaseTryAgainOrContactSupport'),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  deleteTaskGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TaskGroupActions.delete),
      switchMap(({ id }) =>
        this.taskGroupService.deleteTaskGroup(id).pipe(
          mergeMap(() => [
            TaskGroupsActions.load(),
            ToastActions.showInfoMessage({ summary: this.translate('taskGroupDeleted'), detail: '' }),
            TaskGroupActions.deleteTaskGroupSucceeded(),
          ]),
          catchError(() =>
            of(
              ToastActions.showErrorMessage({
                summary: this.translate('somethingWentWrong'),
                detail: this.translate('pleaseTryAgainOrContactSupport'),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(private taskGroupService: TaskGroupService) {
    super('TaskGroupEffects');
  }
}
